module.exports = __webpack_public_path__ + "bradavice_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_1_after_tn.jpg
// module id = 1397
// module chunks = 0